<template>
  <ul
    v-bind:class="{
      depth0: depth == 0,
      depth1: depth == 1,
      depth2: depth == 2,
      depth3: depth == 3,
    }"
  >
    <li v-for="item in items" v-bind:key="item.slug">
      <a v-on:click="itemClicked(item)" v-bind:class="{ open: item.open }">
        {{ item.title || item.name }}
        <span>
          <i
            v-if="!item.open && item.children"
            class="arrow fa fa-angle-right pull-right"
          ></i>
          <i
            v-if="item.open && item.children"
            class="arrow fa fa-angle-down pull-right"
          ></i>
        </span>
      </a>
      <transition name="fade">
        <MenuItems
          v-if="item.open && item.children"
          :items="item.children"
          :depth="childDepth"
        />
      </transition>
    </li>
  </ul>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "MenuItems",
  props: {
    items: Array,
    depth: Number,
  },
  methods: {
    itemClicked: function(item) {
      this.toggleItem(item.slug);

      this.$forceUpdate();
      if (item.iframe) {
        this.activateBySlug(item.slug);
      }
    },
    ...mapActions({
      toggleItem: "openBySlug",
      activateBySlug: "activateBySlug",
    }),
  },
  computed: {
    childDepth: function() {
      return parseInt(this.depth + 1);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
a {
  color: #aeb2b7;
  text-decoration: none;
  display: block;
  padding: 10px 0 10px 0px;
  font-size: 14px;
  font-weight: bold;
  outline: 0;
  transition: all 0.5s;
  cursor: pointer;
}
a.open {
  color: #1abc9c;
}
h3 {
  margin: 40px 0 0;
}
ul {
  padding: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  a {
    padding-right: 10px;
    padding-left: 10px;
  }
}
li {
  display: flex;
  flex-direction: column;
  margin: 0 0;
}
.depth0 {
}
.depth1 {
  background: darken(#293949, 5);
  a {
    padding-left: 15px;
  }
}
.depth2 {
  background: darken(#293949, 10);
  a {
    padding-left: 20px;
  }
}
.depth3 {
  background: darken(#293949, 15);
  a {
    padding-left: 25px;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.15s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-30px);
}
</style>
